// Private calendar-feed subscription. Each user gets an unguessable
// `calendarToken` on their user doc; the calendarFeed Cloud Function
// serves their upcoming jobs as an .ics feed keyed off that token.
// The phone's calendar app subscribes to the webcal:// URL and polls
// it, so jobs stay in sync without the app open.

import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

const FEED_HOST = "us-central1-veloceflowclaude.cloudfunctions.net/calendarFeed";

function randomToken() {
  const bytes = new Uint8Array(20); // 160-bit
  crypto.getRandomValues(bytes);
  return Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");
}

// Return the user's calendar token, generating + persisting one on first use.
export async function ensureCalendarToken(userId, existingToken) {
  if (existingToken && existingToken.length >= 16) return existingToken;
  const token = randomToken();
  await updateDoc(doc(db, "users", userId), { calendarToken: token });
  return token;
}

// Build a brand-new token (used by "reset link" if a feed URL leaks).
export async function regenerateCalendarToken(userId) {
  const token = randomToken();
  await updateDoc(doc(db, "users", userId), { calendarToken: token });
  return token;
}

// opts (owner-only feed variants; the function ignores them for guards):
//   mineOnly — feed carries only jobs the owner is personally assigned to
//   guardId  — feed contains only that guard's jobs (one calendar per
//              guard is how color-coding works: calendar apps ignore
//              per-event colors in subscribed feeds, so each guard's
//              calendar gets its own color in the app instead)
export function calendarSubscribeUrls(token, opts = {}) {
  const params = new URLSearchParams({ token });
  if (opts.mineOnly) params.set("scope", "mine");
  if (opts.guardId) params.set("guard", opts.guardId);
  const q = `?${params.toString()}`;
  return {
    webcal: `webcal://${FEED_HOST}${q}`, // one-tap subscribe on iOS / Google
    https: `https://${FEED_HOST}${q}`,    // paste into Google Calendar "From URL"
  };
}
